import { z } from "zod";

import type { GetOauthConsentParams } from "api/generated/model";

const authorizationRequestSchema = z.object({
    response_type: z.literal("code"),
    client_id: z.string().min(1),
    redirect_uri: z.string().min(1),
    scope: z.literal("mcp").optional(),
    state: z.string().optional(),
    code_challenge: z.string().min(1),
    code_challenge_method: z.literal("S256"),
});

export function parseAuthorizationRequest(
    search: string
): GetOauthConsentParams | null {
    const params = new URLSearchParams(search);
    if (
        Object.keys(authorizationRequestSchema.shape).some(
            (key) => params.getAll(key).length > 1
        )
    ) {
        return null;
    }

    const result = authorizationRequestSchema.safeParse(
        Object.fromEntries(params)
    );
    return result.success ? result.data : null;
}
